@if (url$ | async | safeResourceUrl; as safeUrl) {
  <iframe #iFrame [src]="safeUrl" [title]="supportUrl?.title"></iframe>
}
